import { render } from "./content.vue?vue&type=template&id=1cd9b39d"
import script from "./content.vue?vue&type=script&lang=ts"
export * from "./content.vue?vue&type=script&lang=ts"
script.render = render

export default script